export enum RoleStatuses {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
  Pending = "PENDING",
  Deceased = "DECEASED",
  Unregistered = "UNREGISTERED",

  // TODO: remove these statuses (they are UI specific)
  All = "ALL",
  Draft = "DRAFT",
}
